<div class="container">
  <div class="container-content content ui-page-shell-modern">
    <app-listagem-lotes-faturamento
      [headerItems]="headerItems"
    ></app-listagem-lotes-faturamento>
  </div>
</div>
